export enum InsightGrowthDirection {
  Down = 'DOWN',
  Flat = 'FLAT',
  Up = 'UP',
}

export interface InsightGrowthStat {
  delta?: {
    direction: InsightGrowthDirection;
    formattedValue: string;
  };
  formattedValue: string;
}

export interface ProfitRollupHubCardData {
  avgGpPercentage?: InsightGrowthStat;
  subtitle: string;
  title: string;
  totalSales: InsightGrowthStat;
}

export interface LowestPerformingCustomerRow {
  formattedValue: string;
  restaurantName: string;
  restaurantUUID: string;
  subtitle: string;
}

export interface LowestPerformingCustomersHubCardData {
  byGpPercentage: LowestPerformingCustomerRow[];
  byUnitsSold: LowestPerformingCustomerRow[];
  title: string;
}
